module.exports = __webpack_public_path__ + "img/0ad0428.jpg";